<template>
  <div class="quiz container">
    <div class="top">
      <div class="back_box">
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="title_input">
        <div class="btns">
          <div
            class="one"
            v-for="item in list"
            :key="item.type"
            @click="handleAddQuestion(item)"
          >
            {{ checkType(item.type) }}
          </div>
        </div>
        <el-button class="bank-btn" type="text" @click="show = true"
          >从题库选题<i class="el-icon-arrow-right el-icon--right"></i
        ></el-button>
      </div>
    </div>
    <div class="main">
      <div class="left">
        <div
          class="question"
          v-for="(item, index) in form.questionList"
          :key="item.questionId"
        >
          <div class="box">
            <div class="top-row">
              <h3 class="question-type">
                {{ index + 1 }}. {{ checkType(item.type) }}
              </h3>
              <i class="el-icon-delete" @click="handleDelQuestion(index)"></i>
            </div>
            <component :is="item.type" :form="item" :isEdit="true" />
          </div>
        </div>
      </div>
      <div class="right">
        <div class="settings">
          <h3>设置</h3>
          <el-form ref="form" :model="form">
            <el-form-item label="活动名称" class="name-input">
              <el-input
                v-model="form.name"
                placeholder="请输入活动名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="结束后允许参与者查看正确答案">
              <el-switch v-model="form.afterLookAnswer"></el-switch>
            </el-form-item>
            <!-- <el-form-item label="多选题半对给一半分">
              <el-switch v-model="form.checkboxHalf"></el-switch>
            </el-form-item> -->
            <el-form-item label="活动时长" v-show="form.autoStop">
              <el-input-number
                size="mini"
                v-model="day"
                :controls="false"
                :min="0"
                :max="29"
              ></el-input-number
              ><span style="margin: 0 6px">天</span>
              <el-input-number
                size="mini"
                v-model="hour"
                :controls="false"
                :min="0"
                :max="23"
              ></el-input-number
              ><span style="margin: 0 10px">小时</span>
              <el-input-number
                size="mini"
                v-model="minute"
                :controls="false"
                :min="0"
                :max="59"
              ></el-input-number
              ><span style="margin: 0 10px">分钟</span>
            </el-form-item>
            <el-form-item label="自动结束">
              <el-switch v-model="form.autoStop"></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn-row">
          <el-button
            type="primary"
            @click="handleSave(true)"
            style="margin-right: 50px"
            >立即开始</el-button
          >
          <el-button @click="handleSave(false)">保存</el-button>
        </div>
      </div>
    </div>

    <chooseQuestion
      :show="show"
      @addQuestion="addQuestion"
      @closeChoose="closeChoose"
    />
  </div>
</template>

<script>
import RADIO from "@/components/questionTemplates/assistantMode/radio";
import CHECKBOX from "@/components/questionTemplates/assistantMode/checkbox";
import BOOLEAN from "@/components/questionTemplates/assistantMode/boolean";
import SUPPLY from "@/components/questionTemplates/assistantMode/supply";
import ANSWER from "@/components/questionTemplates/assistantMode/answer";
import chooseQuestion from "./components/chooseQuestion";
import mixinsData from "../mixins";
import { checkType } from "@/utils/index";
import { quizList } from "@/api/assistantMode/activity/quiz";

export default {
  components: {
    RADIO,
    CHECKBOX,
    BOOLEAN,
    SUPPLY,
    ANSWER,
    chooseQuestion,
  },
  mixins: [mixinsData],
  data() {
    return {
      checkType,
      questionType: "",
      list: [
        {
          type: "RADIO",
          question: "",
          optionList: [
            {
              tag: "A",
              option: "",
            },
            {
              tag: "B",
              option: "",
            },
            {
              tag: "C",
              option: "",
            },
          ],
          answerList: [],
          score: 10,
        },
        {
          type: "CHECKBOX",
          question: "",
          optionList: [
            {
              tag: "A",
              option: "",
            },
            {
              tag: "B",
              option: "",
            },
            {
              tag: "C",
              option: "",
            },
          ],
          answerList: [],
          score: 10,
        },
        {
          type: "BOOLEAN",
          question: "",
          optionList: [
            {
              tag: "A",
              option: "对",
            },
            {
              tag: "B",
              option: "错",
            },
          ],
          answerList: [],
          score: 10,
        },
        {
          type: "SUPPLY",
          question: "",
          answerList: [],
          emptyCount: 1,
          score: 10,
        },
        {
          type: "ANSWER",
          question: "",
          answerList: [],
          score: 10,
        },
      ],
      form: {
        classChapterId: null,
        classId: null,
        name: "随堂练习",
        type: "QUIZ",
        afterLookAnswer: false,
        afterLookStatistics: true,
        // checkboxHalf: false,
        autoStop: true,
        duration: null,
        questionList: [],
      },
      day: 0,
      hour: 0,
      minute: 30,
      show: false,
    };
  },
  activated() {
    if (this.$route.query.activityId) this.getList();
  },
  deactivated() {
    this.list = this.$options.data().list;
    this.form = this.$options.data().form;
    this.day = this.$options.data().day;
    this.hour = this.$options.data().hour;
    this.minute = this.$options.data().minute;
  },
  computed: {
    duration() {
      return this.day * 24 * 60 + this.hour * 60 + this.minute;
    },
  },
  methods: {
    getList() {
      let activityId = this.$route.query.activityId;
      this.$loading.show();
      quizList({ activityId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.form.questionList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAddQuestion(question) {
      this.form.questionList.push(question);
    },
    handleDelQuestion(idx) {
      this.form.questionList.splice(idx, 1);
    },
    handleSave(start) {
      this.form.classChapterId = this.$route.query.classChapterId;
      this.form.classId = this.$route.query.id;
      if (start) this.form.status = "STARTED";
      else this.form.status = "PEND";
      this.form.duration = this.duration;
      let check = this.form.questionList.every((item) => {
        return this.checkQuestion(item) === true;
      });
      if (!check) return;
      if (this.$route.query.activityId) {
        // 修改
        this.form.activityId = this.$route.query.activityId;
        this.handleEdit(this.form);
      } else {
        // 新增
        this.handleAdd(this.form);
      }
    },
    // 空验证
    checkQuestion(question) {
      if (!question.question) {
        this.$message.error("题干不能为空");
        return false;
      } else if (!question.score) {
        this.$message.error("题目分值不能为空");
        return false;
      } else if (question.type != "ANSWER") {
        if (question.answerList.length <= 0 || !question.answerList[0]) {
          this.$message.error("答案不能为空");
          return false;
        }
      }
      if (question.type == "RADIO" || question.type == "CHECKBOX") {
        if (
          question.optionList.some((item) => {
            return item.option == "";
          })
        ) {
          this.$message.error("选项不能为空");
          return false;
        }
      } else if (question.type == "SUPPLY") {
        if (
          question.answerList.some((item) => {
            return item == "";
          })
        ) {
          this.$message.error("答案不能为空");
          return false;
        }
      }
      return true;
    },
    addQuestion(questions) {
      this.form.questionList = this.form.questionList.concat(questions);
    },
    closeChoose() {
      this.show = false;
    },
  },
};
</script>

<style lang="less" scoped>
.quiz {
  height: 100%;
  .top {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    overflow: hidden;
    .back_box {
      display: inline-block;
      width: calc(100% - 1126px);
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      p {
        color: #969696;
        font-size: 16px;
      }
    }
    .title_input {
      display: inline-block;
      padding: 24px 30px;
      background-color: #fff;
      width: 1126px;
      vertical-align: middle;
    }
    .btns {
      float: left;
      .one {
        display: inline-block;
        margin-right: 20px;
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #333;
        border: 1px solid #e1e1e5;
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.3s ease;
        &:hover {
          border-color: #1890ff;
        }
      }
    }

    .bank-btn {
      float: right;
    }
  }
  .main {
    margin-top: 20px;
    width: 100%;
    height: calc(100% - 30px - 20px - 88px - 30px);
    .left,
    .right {
      display: inline-block;
      vertical-align: top;
      &.left {
        margin-right: 20px;
        width: 760px;
        height: 100%;
        text-align: left;
        overflow: auto;
        &::-webkit-scrollbar {
          width: 4px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          border-radius: 10px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          background-color: #c8c8c8;
        }
        .question {
          margin-bottom: 20px;
          background-color: #fff;
          .box {
            padding: 20px;
            .top-row {
              margin-bottom: 10px;
              overflow: hidden;
              .question-type {
                float: left;
              }
              .el-icon-delete {
                float: right;
              }
            }
          }
        }
      }
      &.right {
        width: calc(100% - 760px - 20px);
        text-align: center;
        .settings {
          padding: 25px;
          text-align: left;
          background-color: #fff;
          h3 {
            margin-bottom: 10px;
          }
          .name-input {
            ::v-deep .el-input {
              width: 80%;
            }
          }
          .el-input-number {
            width: 60px;
          }
        }
        .btn-row {
          display: inline-block;
          margin-top: 40px;
        }
      }
    }
  }
}
</style>